export const CURRENCY_SYMBOLS = { INR: '₹', USD: '$', AED: 'AED ', GBP: '£', SGD: 'S$', EUR: '€', SAR: 'SAR ', AUD: 'A$', CAD: 'C$' };
export const money = (n, c = 'INR') => `${CURRENCY_SYMBOLS[c] || `${c} `}${(n || 0).toLocaleString()}`;
